// initial state reducer first
export const composeReducers = (...func) => (state, action) =>
  func.reduce((accState, f) => f(accState, action), state);
